import { createContext, Dispatch, SetStateAction } from 'react';

type FullscreenContext = {
    fullscreen: boolean;
    setFullscreen: Dispatch<SetStateAction<boolean>>;
};

export const Fullscreen = createContext<FullscreenContext>({
    fullscreen: false,
    setFullscreen: () => {}
});